import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import style from './ZingNotifications.module.css'
import {
    BATTERY_STALE_MS,
    isZingNotificationDevice,
} from '../../../utils/zingNotifications'

// Battery knob drawn on the right half of the connection button, fed by the firmware's
// once-a-minute battery notification (no polling of the device).
function BatteryIndicator() {
    const battery = useSelector((state) => state.zingNotification.battery)
    const isConnected = useSelector((state) => state.webSerial.isConnected)
    const device = useSelector((state) => state.device)
    const [, forceRender] = useState(0)

    // Re-render once when the current reading goes stale so it is hidden
    useEffect(() => {
        if (!battery) return undefined
        const remaining = battery.receivedAt + BATTERY_STALE_MS - Date.now()
        const timer = setTimeout(() => forceRender((n) => n + 1), Math.max(remaining, 0) + 50)
        return () => clearTimeout(timer)
    }, [battery])

    if (
        !battery ||
        !isConnected ||
        !isZingNotificationDevice(device.connectedDevice, device.deviceVersion) ||
        Date.now() - battery.receivedAt > BATTERY_STALE_MS
    )
        return null

    const { percent } = battery
    const level =
        percent <= 20
            ? style.batteryLow
            : percent <= 50
              ? style.batteryMid
              : style.batteryOk
    return (
        <div
            className={`${style.batteryPill} ${level}`}
            title={`Zing battery ${percent}%${percent <= 20 ? ' - low, please charge' : ''}`}
            data-testid="zing-battery"
        >
            <span className={style.batteryRow}>
                <span className={style.batteryBody}>
                    <span className={style.batteryFill} style={{ width: `${percent}%` }} />
                    <span className={style.batteryCells} />
                </span>
                <span className={style.batteryCap} />
            </span>
            <span className={style.batteryText}>{percent}%</span>
        </div>
    )
}

export default React.memo(BatteryIndicator)
